interface CategoryToolbarProps {
  tags: string[];
  activeTag: string;
  onTagChange: (tag: string) => void;
  sortKey: 'latest' | 'hot';
  onSortChange: (key: 'latest' | 'hot') => void;
  keyword: string;
}

export default function CategoryToolbar({
  tags,
  activeTag,
  onTagChange,
  sortKey,
  onSortChange,
  keyword,
}: CategoryToolbarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4">
      {keyword && (
        <p className="mb-3 flex items-center gap-2 text-sm text-foreground-600">
          <i className="ri-search-line text-base text-primary-500" aria-hidden="true"></i>
          正在筛选关键词：<span className="font-semibold text-foreground-900">{keyword}</span>
        </p>
      )}

      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <button
            key={tag}
            type="button"
            onClick={() => onTagChange(tag)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
              activeTag === tag
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-50 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {tag}
          </button>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
        <span className="text-xs text-foreground-500">排序方式</span>
        <div className="flex items-center gap-1 rounded-full bg-background-50 p-1">
          {(
            [
              { key: 'latest', label: '最新发布' },
              { key: 'hot', label: '阅读热度' },
            ] as const
          ).map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onSortChange(option.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition-colors ${
                sortKey === option.key
                  ? 'bg-foreground-950 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}